import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dkshdskwmr: FaireBrandEntity = {
  token: "b_dkshdskwmr",
  type: "brand",
  name: "King Henry's",
  avatarUrl:
    "https://cdn.faire.com/fastly/5a89eeb9f7e2f6c6126b6448bf64e6ca33bd82034a5d0f2722efffc6dd6f2eff.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5164c94fd1156d7adece64e2a18f04543d0eea0f8d37128807d53d13f427db6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5a89eeb9f7e2f6c6126b6448bf64e6ca33bd82034a5d0f2722efffc6dd6f2eff.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5164c94fd1156d7adece64e2a18f04543d0eea0f8d37128807d53d13f427db6c.png",
  location: "Valencia, CA, USA",
  minimumOrderDollars: 35,
  rating: 4.4,
  reviewCount: 5,
  isInsider: true,
  description:
    "King Henry's is a woman owned national snack company that focuses on three things: Cost, Quality, and Variety. For over 30 years, King Henry’s has produced premium candy, nuts, trail mixes, and assorted sweets. King Henry’s offers a wide variety of high quality products ensuring that you get the most value for your dollar. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:30.515Z",
    importedBy: "entity-db-cli",
  },
};
